module.exports = __webpack_public_path__ + "media/bell_announcement.280bb5a3.mp3";